














// @ts-ignore
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BlockoutPeriod } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop() readonly blockoutPeriod: BlockoutPeriod;
}
